import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'when_was_the_last_risk_assessment_conducted'

export const dataPointDefinition = {
  retracedId: 'when_was_the_last_risk_assessment_conducted',
  name: 'When was the last risk assessment conducted?',
  description: '',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Within the last 6 months',
      key: 'WIN_THE_LAST_6_MONTHS',
      slcpIndex: 1,
      slcpOptionName: 'lra-conducted',
    },
    {
      name: 'Within the last 12 months',
      key: 'WIN_THE_LAST_12_MONTHS',
      slcpIndex: 2,
      slcpOptionName: 'lra-conducted',
    },
    {
      name: 'Within the last 24 months',
      key: 'WIN_THE_LAST_24_MONTHS',
      slcpIndex: 3,
      slcpOptionName: 'lra-conducted',
    },
    {
      name: 'Other',
      key: 'OTHER',
      slcpIndex: 4,
      slcpOptionName: 'lra-conducted',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['WIN_THE_LAST_6_MONTHS', 'WIN_THE_LAST_12_MONTHS', 'WIN_THE_LAST_24_MONTHS', 'OTHER'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-16--3',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 14340,
  sectionId: '2.2.9.1',
  impactArea: 'Risk Assessment',
  impactAreaId: 'RISK_ASSESSMENT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
